import { useEffect, useRef, useState } from 'react';

interface DelayedLoadingOptions {
  /** 骨架屏出现前的延迟：快于此值完成的请求完全不闪骨架屏 */
  delay?: number;
  /** 骨架屏一旦出现的最短停留时间，防止一闪而过 */
  minDuration?: number;
}

/** 防闪烁加载态。jest fake timers 会同时 mock Date.now，测试可精确断言。 */
export function useDelayedLoading(
  loading: boolean,
  { delay = 150, minDuration = 300 }: DelayedLoadingOptions = {},
): boolean {
  const [showSkeleton, setShowSkeleton] = useState(false);
  const shownAtRef = useRef<number | null>(null);

  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => {
        shownAtRef.current = Date.now();
        setShowSkeleton(true);
      }, delay);
      return () => clearTimeout(timer);
    }
    if (shownAtRef.current === null) {
      setShowSkeleton(false);
      return;
    }
    const elapsed = Date.now() - shownAtRef.current;
    const remain = Math.max(0, minDuration - elapsed);
    const timer = setTimeout(() => {
      shownAtRef.current = null;
      setShowSkeleton(false);
    }, remain);
    return () => clearTimeout(timer);
  }, [loading, delay, minDuration]);

  return showSkeleton;
}
